import React, { useEffect } from "react";
import SimpleBar from "components/SimpleBar";
import { getDrawerMenu } from "menu/menuItems";
import NavGroup from "layouts/Drawer/NavGroup";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { getStockSettingsThunk } from "store/reducers/inventory/stock/inventorySettingsSlice";

function DrawerContent() {
  const roles = useSelector((state) => state.auth.user.roles);
  const inventorySettings = useSelector(
    (state) => state.inventorySettings.data
  );
  useEffect(() => {
    dispatch(getStockSettingsThunk());
  }, []);
  return (
    <SimpleBar style={{ maxHeight: "90%" }}>
      {getDrawerMenu(roles, inventorySettings).map((item) => (
        <NavGroup item={item} key={item.id} />
      ))}
    </SimpleBar>
  );
}

export default DrawerContent;
